export default __webpack_public_path__ + "static/media/2015-12-0014.67b1163e.jpg";